export default __webpack_public_path__ + "static/media/39.13b19749.png";